import type { IMustPayload } from '@/types'
import { getMustApi } from '@/utils'
import type { IMustResponse } from '@/types'

export const fetchMustData = async (
  accountId: string,
  accountName: string,
  productId: string,
  dimensions: string[],
  metrics: string[],
  filters: any[],
  startDate: string,
  endDate: string,
  placements: string[],
  page: number = 1,
  limit: number = 100,
): Promise<IMustResponse | null> => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 30000)

  const normalizedDimensions = dimensions.map(dimension => ({
    name: dimension,
  }))
  const normalizedMetrics = metrics.map(metric => ({ name: metric }))
  const filteredPlacements = {
    name: 'placement',
    operator: 'IN',
    value: placements,
  }
  const normalizedFilters = [
    {
      name: 'source',
      operator: '=',
      value: productId,
    },
    {
      name: 'account',
      operator: 'IN',
      value: [accountId, accountName],
    },
    ...filters,
    filteredPlacements,
  ]
  const payload: IMustPayload = {
    dimensions: normalizedDimensions,
    metrics: normalizedMetrics,
    filters: normalizedFilters,
    dateRanges: [
      {
        startDate,
        endDate,
      },
    ],
    limit,
    page,
  }

  const mustEndpoint = getMustApi()
  const path = 'analyze'
  const url = new URL(`${mustEndpoint}/${path}`)
  url.searchParams.set('product', String(productId ?? '').trim())
  url.searchParams.set('accountId', String(accountId ?? '').trim())
  url.searchParams.set('juid', String(accountId ?? '').trim())
  const requestUrl = url.toString()

  const response = await fetch(requestUrl, {
    method: 'POST',
    body: JSON.stringify(payload),
    signal: controller.signal,
  })

  clearTimeout(timeoutId)

  if (!response.ok) {
    console.error('micro_srp', 'fetchMustData', response.status)
    return null
  }

  return await response.json()
}
